import { Box, Button, Grid2, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const BankDetail = () => {
    const [bank, setBank] = useState();
    const [hasBank, setHasBank] = useState(false)
  const [errors, setErrors] = useState({});
  const storedUser = JSON.parse(localStorage.getItem("user"))
  const [btnLoading, setBtnLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const getBank = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/bank-detail?username=${storedUser.username}`,
                {headers: {Authorization: `Bearer ${storedUser.accessToken}`}}
            )
            setBank(res.data);
            setHasBank(true);
        } catch (error) {
            console.log(error)
        }
    }
    getBank();
  }, [])

  const handleChange = (e) => {
    setBank({ ...bank, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};
    const data = bank || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    if (isEmpty(data.bankName)) newErrors.bankName = "Bank Name is required";
    if (isEmpty(data.accountNumber))
      newErrors.accountNumber = "Bank Account Number is required";
    if (isEmpty(data.ifscCode)) {
      newErrors.ifscCode = "IFSC code is required";
    } else {
      const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
      if (!ifscRegex.test(data.ifscCode)) {
        newErrors.ifscCode = "Enter a valid IFSC code (e.g., SBIN0001234)";
      }
    }
    if (isEmpty(data.accountName))
      newErrors.accountName = "Account Name is required";
    if (isEmpty(data.type))
      newErrors.type = "Account Type is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAdd = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/bank-detail`,
        {
          bankName: bank.bankName,
          accountNumber: bank.accountNumber,
          ifscCode: bank.ifscCode,
          accountName: bank.accountName,
          type: bank.type,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };
  const handleUpdate = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/bank-detail`,
        {
          bankName: bank.bankName,
          accountNumber: bank.accountNumber,
          ifscCode: bank.ifscCode,
          accountName: bank.accountName,
          type: bank.type,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };
  return (
    <div style={{position: 'relative'}}>
        {btnLoading && <div className="loading-div"></div> }
        <div className="dashboard-container">
        <Typography className="form-title">Bank Details</Typography>
        <Grid2 container columnSpacing={2}>
            <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="bankName">Bank Name</label>
            <input
                type="text"
                id="bankName"
                name="bankName"
                className={`${errors.bankName && "input-error"}`}
                onChange={handleChange}
                value={bank && bank.bankName}
            />
            {errors.bankName && <p className="error">{errors.bankName}</p>}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="accountNumber">Bank Account Number</label>
            <input
                type="text"
                id="accountNumber"
                name="accountNumber"
                className={`${errors.accountNumber && "input-error"}`}
                onChange={handleChange}
                value={bank && bank.accountNumber}
            />
            {errors.accountNumber && (
                <p className="error">{errors.accountNumber}</p>
            )}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="ifsc">IFSC Code</label>
            <input
                type="text"
                id="ifscCode"
                name="ifscCode"
                className={`${errors.ifscCode && "input-error"}`}
                onChange={handleChange}
                value={bank && bank.ifscCode}
            />
            {errors.ifscCode && <p className="error">{errors.ifscCode}</p>}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="accountName">Account Name</label>
            <input
                type="text"
                id="accountName"
                name="accountName"
                className={`${errors.accountName && "input-error"}`}
                onChange={handleChange}
                value={bank && bank.accountName}
            />
            {errors.accountName && <p className="error">{errors.accountName}</p>}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="type">Account Type</label>
            <input
                type="text"
                id="type"
                name="type"
                className={`${errors.type && "input-error"}`}
                onChange={handleChange}
                value={bank && bank.type}
            />
            {errors.type && <p className="error">{errors.type}</p>}
            </Grid2>
        </Grid2>
        </div>
        <Box className='btn-container' sx={{gap: 5}}>
            <Button className="btn-outlined" onClick={() => navigate("/superadmin-dashboard")}>Back</Button>
            <Button className="btn-contained" onClick={hasBank ? handleUpdate : handleAdd}>{hasBank ? "Update": "Add"}</Button>
        </Box>
    </div>
  );
};

export default BankDetail;
